(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["3p-truevault-footer"] && !Shopify.designMode) return;
  try {
    // openConsentModal comes from the loaded polaris.js, not TrueVault's docs; without it the href
	// reloads the page with the manager open.
	document.addEventListener('click', (event) => {
		if (
			event.defaultPrevented ||
			event.button !== 0 ||
			event.metaKey ||
			event.ctrlKey ||
			event.shiftKey ||
			event.altKey
		) {
			return;
		}

		const link =
			event.target instanceof Element && event.target.closest('.truevault-polaris-open-consent-manager-link');
		if (!link || typeof window.polaris?.openConsentModal !== 'function') {
			return;
		}

		// Opened before preventDefault, so if the call throws the href still loads the manager.
		window.polaris.openConsentModal();
		event.preventDefault();
	});
  } catch(e) { console.error(e); }
})();

})();
